import customerSearchComponent from './customer-search.component';

const customerSearchModule = angular.module('customerSearch', [
])
  .component('customerSearch', customerSearchComponent)
  .name;

export default customerSearchModule;
